// ============================================================================
// SPANISH TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Preguntas reflexivas e interesantes sobre la fe

export const funQuestions = [
  {
    question: "¿Qué acto de amor de Jesús te inspira más en tu vida diaria?",
    emoji: "❤️",
    theme: "amor"
  },
  {
    question: "Si pudieras compartir una comida con un personaje bíblico, ¿quién sería y por qué?",
    emoji: "🍞",
    theme: "encuentro"
  },
  {
    question: "¿Qué parábola de Jesús te habla más profundamente y por qué?",
    emoji: "🌱",
    theme: "enseñanza"
  },
  {
    question: "¿Cómo se manifiesta la paz de Dios en tu vida?",
    emoji: "🕊️",
    theme: "paz"
  },
  {
    question: "¿Qué milagro de Jesús te gustaría haber presenciado?",
    emoji: "✨",
    theme: "fe"
  },
  {
    question: "Si tuvieras que describir el amor de Dios en una palabra, ¿cuál sería?",
    emoji: "💝",
    theme: "amor divino"
  },
  {
    question: "¿Qué versículo de la Biblia te ha ayudado en un momento difícil?",
    emoji: "📖",
    theme: "consuelo"
  },
  {
    question: "¿Cómo puedes ser luz del mundo hoy?",
    emoji: "💡",
    theme: "testimonio"
  }
];

export default funQuestions;
